import ContainerFlex from "components/ContainerFlex";
import * as St from "./styles";
import AppButton from "components/AppButton/AppButton";
import { RouteNames } from "routes/routes";
import { useHistory } from "react-router-dom";
import { useAppSelector } from "redux/app/hooks";
import { moneyMask } from "utils/mask";
import { SecurityPageProps } from "models/security";
import ReactToPrint from "react-to-print";
import { useRef } from "react";
import PrintSummary from "../PrintSummary";

const CreditSummary = () => {
  const history = useHistory();

  const componentRef = useRef<HTMLDivElement>(null);

  const {
    cliente: { valuePaymentInvoice, valueAntecipationPurchase },
  } = useAppSelector((state) => state.cliente);

  const serviceCharge = (Number(valuePaymentInvoice || valueAntecipationPurchase) || 0) * 0.0499;

  const clickBack = () => {
    history.push(RouteNames.RESUMO_DEBITO_FATURA_PAGAMENTO);
  };

  const clickPayments = () => {
    const propsRouter: SecurityPageProps = {
      nextStep: RouteNames.FEEDBACK_FATURA_PINPAD,
      backStep: RouteNames.RESUMO_DEBITO_FATURA_PAGAMENTO,
      installmentPaymentInvoice: "1",
      title: "Pagar com cartão de débito",
      description:
        "Tudo certo! Agora confirme no Pinpad o valor selecionado e aproxime ou insira o teu cartão de débito.",
    };

    history.push({
      pathname: RouteNames.FEEDBACK_FATURA_PINPAD,
      state: { ...propsRouter },
    });
  };

  return (
    <ContainerFlex>
      <St.TitleH1>Pagar com cartão de débito</St.TitleH1>
      <ContainerFlex>
        <ContainerFlex center>
          <St.SpanDescription>
            Confirme o valor de pagamento que será cobrado em teu cartão de
            débito:
          </St.SpanDescription>
          <ContainerFlex row>
            <ContainerFlex padding={10}>
              <ContainerFlex>
                <ContainerFlex style={{ paddingLeft: "7rem" }}>
                  <St.SpanTitleInvoice>Valor informado:</St.SpanTitleInvoice>
                  <ContainerFlex row>
                    <St.BiggerTextInvoice>
                      {moneyMask(Number(valuePaymentInvoice || valueAntecipationPurchase))}
                    </St.BiggerTextInvoice>
                  </ContainerFlex>
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>

            <ContainerFlex padding={10}>
              <ContainerFlex>
                <ContainerFlex
                  style={{ paddingLeft: "7rem" }}
                  center
                  horizontal
                  align="flex-start"
                >
                  <St.SpanTitleInvoice>
                    Taxa de serviços de 4,99%:
                  </St.SpanTitleInvoice>
                  <ContainerFlex row>
                    <St.BiggerTextInvoice>
                      {moneyMask(serviceCharge)}
                    </St.BiggerTextInvoice>
                  </ContainerFlex>
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>

            <ContainerFlex padding={10}>
              <ContainerFlex>
                <ContainerFlex
                  style={{ paddingLeft: "7rem" }}
                  center
                  horizontal
                  align="flex-start"
                >
                  <St.SpanTitleInvoiceBold>
                    Valor pagamento
                  </St.SpanTitleInvoiceBold>
                  <ContainerFlex row>
                    <St.BiggerTextInvoice>
                      {moneyMask(Number(valuePaymentInvoice || valueAntecipationPurchase) + serviceCharge)}
                    </St.BiggerTextInvoice>
                  </ContainerFlex>
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex center horizontal row space>
        <AppButton
          content="Voltar"
          route={RouteNames.ATENDIMENTO_FATURA}
          outlined={true}
          click={clickBack}
        />
        <button className="normal" onClick={() => clickPayments()}>
          {`Pagar ${moneyMask(Number(valuePaymentInvoice || valueAntecipationPurchase) + serviceCharge)}`}
        </button>
        <ReactToPrint
          trigger={() => <button className="normal">Imprimir</button>}
          content={() => componentRef.current}
        />
      </ContainerFlex>
      <div style={{ visibility: "hidden" }}>
        <div ref={componentRef}>
          <PrintSummary />
        </div>
      </div>
    </ContainerFlex>
  );
};

export default CreditSummary;
